/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NavigationExtras, Router } from '@angular/router';
import { PopupModalComponent } from '../libs/shared/components/popup/popup-modal.component';
import { PopupType } from '../libs/shared/components/popup/popup-type.enum';
import { BehaviorSubject } from 'rxjs';
import { MultipleDeviceDetectedPopupComponent } from '../libs/shared/components/multiple-device-detected-popup/multiple-device-detected-popup.component';

@Injectable({
    providedIn: 'root',
})
export class ErrorService {
    public is401ErrorTriggered: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public isMultipleDeviceLoginDetected: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    private isShowError = true;
    private suppressErrors = false;

    constructor(
        private dialog: MatDialog,
        private router: Router,
    ) {}

    /**
     * Temporarily suppress error modals (useful after successful operations like email verification)
     */
    public setSuppressErrors(suppress: boolean): void {
        this.suppressErrors = suppress;
    }

    showError(error: any, toRoute?: string, extras?: NavigationExtras): void {
        if (!error?.message) {
            return;
        }

        // Skip showing error if errors are temporarily suppressed
        if (this.suppressErrors) {
            return;
        }

        if (!this.isShowError) {
            return;
        }

        const errorMessage = error.message;
        let dialogRef;

        if (!this.isMultipleDeviceLoginDetected.value) {
            dialogRef = this.dialog.open(PopupModalComponent, {
                data: {
                    message: errorMessage,
                    type: PopupType.Alert,
                },
            });
        } else {
            dialogRef = this.dialog.open(MultipleDeviceDetectedPopupComponent, {
                autoFocus: false,
                disableClose: true
            });
        }

        if (this.is401ErrorTriggered.value) {
            this.isShowError = false;
        } else {
            this.isShowError = true;
        }

        dialogRef.afterClosed().subscribe(async () => {
            this.isShowError = true;
            this.isMultipleDeviceLoginDetected.next(false);
            this.is401ErrorTriggered.next(false);

            if (extras && toRoute) {
                this.router.navigate([toRoute, extras]);
            }

            if (toRoute) {
                this.router.navigate([toRoute]);
            }
        });
    }
}
